module.exports = __webpack_public_path__ + "static/media/mainLogo.46fee013.webp";